import formatName from "./formatName";

export default function heroPath(heroName, role) {
    const path = `/hero/${formatName(heroName).replace(/ /g, "_")}`;
    if (role) return `${path}?role=${role}`;
    return path;
}
